import { IColumn } from '../../components';

export const KpiColumns: IColumn[] = [
  {
    id: 'kpi',
    name: '',
    width: '36%',
  },
  {
    id: 'globalBenchmarkKpi',
    name: 'Global Benchmark',
    width: '15%',
  },
  {
    id: 'intlBenchmarkKpi',
    name: "Int'l Benchmark",
    width: '14%',
  },
  {
    id: 'avedaSalonData',
    name: 'Salon Data',
    width: '14%',
  },
  {
    id: 'status',
    name: 'Status',
    width: '23%',
    iconDescription:
      "The status of KPI's as they compare to the Aveda Business College global benchmarks.",
  },
] as const;

export enum KpiValues {
  'inc_yoy' = 'Inc YOY',
  'flat_ly' = 'Flat to LY',
  'negative_ly' = 'Decr to LY',
}

export enum SalonKpiValues {
  'inc_yoy' = 'Increasing',
  'flat_ly' = 'Flat to LY',
  'negative_ly' = 'Decreasing',
}

export const statusOrder: { [key: string]: number } = {
  below: 1,
  met: 2,
  above: 3,
};
